import { Box, Card, Group, SimpleGrid, Stack, Text } from "@mantine/core";
import { MONEY_TAG_ICON_URL } from "../../constants/operatorListConstants";

/** KPI cards (Figma 1200): primary icon + label/value only — no secondary trend graphic. */
const OperatorKpiCards = ({ cards }) => (
  <Box maw={1200} w="100%" mx="auto">
    <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing={24}>
      {cards.map((card, index) => (
        <Card key={`${card.label}-${index}`} p={16} radius={8} mih={96}>
          <Group gap={24} wrap="nowrap" align="flex-start" h="100%">
            <Box
              w={64}
              h={64}
              style={{
                borderRadius: 8,
                background: "#FFF5D9",
                position: "relative",
                flexShrink: 0,
              }}
            >
              <Box
                component="img"
                src={MONEY_TAG_ICON_URL}
                alt=""
                w={32}
                h={32}
                style={{
                  position: "absolute",
                  top: 18,
                  left: 16,
                  objectFit: "contain",
                  display: "block",
                }}
              />
              </Box>
            <Stack gap={8}>
              <Text size={14} fw={500} lh="18px" c="#697883">
                {card.label}
              </Text>
              <Text fw={600} fz={24} lh="30px" c="#092C4C">
                {card.value}
              </Text>
            </Stack>
          </Group>
        </Card>
      ))}
    </SimpleGrid>
  </Box>
);

export default OperatorKpiCards;